module.exports = __webpack_public_path__ + "img/xlsx.3125ec61.svg";